import { api, formatApiError } from "@/lib/api";

// Sequential on purpose: the AI backend handles one request at a time.
export async function generateSubjects(subjects, ageGroup, { category = "theme", onProgress, onCredits, onError } = {}) {
  const made = [];
  for (let i = 0; i < subjects.length; i++) {
    onProgress?.({ done: i, total: subjects.length, current: subjects[i] });
    try {
      const { data } = await api.post("/pages/generate", { prompt: subjects[i], age_group: ageGroup, category }, { timeout: 180000 });
      made.push(data.page);
      onCredits?.(data.credits);
    } catch (e) {
      onError?.(subjects[i], formatApiError(e));
      if (e.response?.status === 402) break;
    }
  }
  return made;
}
